import { createRoot } from 'react-dom/client';

import { Homepage } from './homepage.jsx';

const container = document.getElementById("app");
const root = createRoot(container);
root.render(<Homepage />);
